class CartDrawerSection extends HTMLElement {
  cartUpdateUnsubscriber = undefined;
  constructor() {
    super();

    this.cartType = this.dataset.cartType;
    this.drawerClass = "wt-cart__drawer";
    this.drawer = this.querySelector(`.${this.drawerClass}`);
    this.classDrawerActive = `${this.drawerClass}--open`;
    this.pageOverlayClass = "page-overlay-cart";
    this.activeOverlayBodyClass = `${this.pageOverlayClass}-on`;
    this.body = document.body;
    this.triggerQuery = [
      `.wt-cart__trigger`,
      `.wt-cart__back-link`,
      `.${this.pageOverlayClass}`,
    ].join(", ");
    this.triggers = () => document.querySelectorAll(this.triggerQuery);
    this.isOpen = false;
    this.isCartPage = window.location.pathname === window.routes.cart_url;
    this.closeButton = () => this.querySelector(".wt-cart__drawer__close");
    this.mainTrigger = document.querySelector(".wt-cart__trigger");
    this.toggleEelements = () =>
      this.querySelectorAll(this.dataset.toggleTabindex);
  }

  connectedCallback() {
    if (this.cartType === "page" || this.isCartPage) {
      document.addEventListener('cart-drawer:refresh', (e) => this.refreshCartDrawer(e))
      return;
    }

    this.init();
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      if (this.isOpen) {
        setTabindex(this.toggleEelements(), "0");
        this.closeButton().focus();
      }
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  getFocusableElements() {
    const focusableElementsSelector =
      "button, [href], input, select, [tabindex]";
    const focusableElements = () =>
      Array.from(this.querySelectorAll(focusableElementsSelector)).filter(
        (el) => !el.hasAttribute("disabled") && el.tabIndex >= 0,
      );

    return {
      focusableElements,
      first: focusableElements()[0],
      last: focusableElements()[focusableElements().length - 1],
    };
  }

  temporaryHideFocusVisible() {
    document.body.classList.add("no-focus-visible");
  }

  onToggle() {
    if (this.hasAttribute("open")) {
      this.removeAttribute("open");
      this.isOpen = false;
      this.mainTrigger.focus();
      this.temporaryHideFocusVisible();
      setTabindex(this.toggleEelements(), "-1");
    } else {
      this.setAttribute("open", "");
      this.isOpen = true;
      this.closeButton().focus();
      this.temporaryHideFocusVisible();
      setTabindex(this.toggleEelements(), "0");
    }
  }
toggleDrawerClasses() {
  this.onToggle();
  if (this.drawer) this.drawer.classList.toggle(this.classDrawerActive);
  this.body.classList.toggle(this.activeOverlayBodyClass);
}



  init() {
    this.addEventListener("keydown", (e) => {
      const isTabPressed =
        e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
      const { first, last } = this.getFocusableElements();

      if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
        if (this.isOpen) {
          this.toggleDrawerClasses();
        }
      }

      if (isTabPressed) {
        if (e.shiftKey && document.activeElement === first) {
          last.focus();
          e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === last) {
          first.focus();
          e.preventDefault();
        }
      }
    });

   this.triggers().forEach((trigger) => {
  trigger.addEventListener("click", (e) => {
    if (!e.isTrusted) return; // ✅ يفتح بس من ضغط المستخدم الحقيقي
    e.preventDefault();
    this.toggleDrawerClasses();
  });
});

    this.addEventListener("click", (e) => {
      if (e.target.classList.contains("wt-cart__drawer__close")) {
        e.preventDefault();
        this.toggleDrawerClasses();
      }
    });

    document.addEventListener('cart-drawer:refresh', (e) => this.refreshCartDrawer(e))
  }

renderContents(parsedState) {
  this.getSectionsToRender().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);

    if (!sectionElement) return;

    sectionElement.innerHTML = this.getSectionInnerHTML(
      parsedState.sections[section.id],
      section.selector
    );
  });

  // ✅ ممنوع فتح الكارت تلقائيًا بعد Add to cart
  // لو الكارت مفتوح يدويًا بالفعل، نعمل focus بس
  if (this.isOpen) {
    const btn = this.closeButton && this.closeButton();
    if (btn) btn.focus();
  }
}


  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  refreshCartDrawer(e){
    const sectionsToRender = this.getSectionsToRender();
    fetch(`${window.Shopify.routes.root}?sections=${sectionsToRender[0].id},${sectionsToRender[1].id}`)
    .then(response => response.json())
    .then((response) => {
      const parsedState = {
        "sections": response
      }
      this.renderContents(parsedState, false);
    })
    .catch(e => {
      console.log(e)
    })
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawerSection);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
/* ===========================
   CART EXPIRY (PRODUCTION)
   - Expires cart after 24 hours
   - Clears cart silently (does NOT open drawer)
   =========================== */
(() => {
  const EXPIRY_MS = 24 * 60 * 60 * 1000; // ✅ 24 hours
  const CHECK_EVERY_MS = 60 * 1000;      // check every 60 seconds (خفيف)
  const TS_KEY = 'hepta_cart_expiry_ts';

  const log = (...a) => console.log('[cart-expiry]', ...a);

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart.js failed');
    return res.json();
  }

  async function clearCart() {
    const res = await fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: ''
    });
    if (!res.ok) throw new Error('cart/clear.js failed');
  }

  // ✅ تحديث الأيقونة/الدراور بدون فتحه
  function silentRefreshUI() {
    // تحديث bubble لو موجود
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      fetch(`${window.Shopify.routes.root}?sections=cart-icon-bubble`)
        .then(r => r.json())
        .then((data) => {
          if (data && data['cart-icon-bubble']) bubble.innerHTML = data['cart-icon-bubble'];
        })
        .catch(() => {});
    }

    // لو الدراور مفتوح يدويًا فقط، ساعتها نحدّثه
    const drawer = document.querySelector('cart-drawer');
    const isOpen = drawer && drawer.hasAttribute('open');
    if (isOpen) {
      document.dispatchEvent(new Event('cart-drawer:refresh'));
    }
  }

  async function checkExpiry() {
    try {
      const cart = await getCart();

      // empty cart => reset
      if (!cart?.items?.length) {
        localStorage.removeItem(TS_KEY);
        return;
      }

      // start timer if missing
      let ts = Number(localStorage.getItem(TS_KEY));
      if (!ts) {
        ts = Date.now();
        localStorage.setItem(TS_KEY, String(ts));
        log('timer started');
      }

      const age = Date.now() - ts;

      if (age > EXPIRY_MS) {
        log('expired -> clearing cart silently...');
        await clearCart();
        localStorage.removeItem(TS_KEY);

        // ✅ تحديث واجهة السلة بدون فتح الدراور
        silentRefreshUI();
      }
    } catch (e) {
      // keep quiet in production
      // console.warn('[cart-expiry] error:', e);
    }
  }

  // ✅ لما يحصل أي تحديث في السلة (إضافة/حذف/تعديل) نعيد ضبط الوقت
  function resetTimer() {
    localStorage.setItem(TS_KEY, String(Date.now()));
  }

  document.addEventListener('DOMContentLoaded', () => {
    checkExpiry();
    setInterval(checkExpiry, CHECK_EVERY_MS);
  });

  // Listen for your theme cart updates if available
  try {
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => resetTimer());
    }
  } catch {}

  // Also catch common cart AJAX calls (safe fallback)
  try {
    const origFetch = window.fetch;
    window.fetch = function(input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const p = origFetch.apply(this, arguments);
      if (url.includes('/cart/') && (url.includes('add') || url.includes('change') || url.includes('update'))) {
        p.finally(() => resetTimer());
      }
      return p;
    };
  } catch {}
})();
